export default __webpack_public_path__ + "static/media/demand.70f9d066.svg";